<div class="flex items-center gap-2">
  @if (image(); as imgUrl) {
    <img
      [src]="imgUrl"
      [alt]="name() || 'Avatar'"
      [class]="avatarClasses()"
      i18n-alt
    />
  } @else {
    @if (initials(); as name) {
      <div [class]="avatarClasses() + ' cursor-pointer'">
        {{ name }}
      </div>
    } @else {
      <div
        class="bg-primary flex font-medium items-center justify-center object-cover rounded-full shrink-0 size-9 text-sm text-on-accent cursor-pointer"
      >
        <i class="pi pi-user"></i>
      </div>
    }
  }
  @if (showLabel() && name()) {
    <span [class]="labelClasses()">{{ name() }}</span>
  }
</div>
